import log from '$lib/utils/log';
import type { ISbStory, ISbStoryData } from '@storyblok/js';

export function hasReference(pages: Array<string>, pathname: string) {
	return pages.map((p) => (['home'].includes(p) ? '/' : `/${p}`)).includes(pathname);
}

// TODO: we can get rid of this and use the new page_filter block
export function withSlugs<T extends { pages: string[] }>(story: ISbStory<T>): ISbStoryData<T> {
	story.data.story.content.pages = story.data.story.content.pages.map((uuid) => {
		const relation = story.data.rels.find((rel) => rel.uuid === uuid);
		if (!relation) {
			log.warn('Cannot resolve page relation', {
				origin: story.data.story.full_slug,
				missing_page_uuid: uuid,
				rel_slugs: story.data.rels.map((r) => r.full_slug).join(', ')
			});
			return '';
		}

		return relation.full_slug.endsWith('/') ? relation.full_slug.slice(0, -1) : relation.full_slug;
	});

	return story.data.story;
}
